import styled from "styled-components";

export const CardWrapper = styled.div`
  overflow-y: auto;
  width: 90%;
`;

export const CardData = styled.div`
  padding: 2rem;
  display: flex;
  border: 1px solid black;
`;

export const CardDataList = styled.ul`
  font-size: 1.3rem;
  font-family: Montserrat;
  font-style: italic;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.02em;
  text-align: left;
`;

export const CardDataLi = styled.li``;
